import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import Footer from "../../comum/components/Footer";
import {Row, Col, Container, FormGroup, Label, Button} from 'reactstrap';
import {IconeCarregar, IconeDelete} from "../../comum/components/Icones";
import FooterContent from "../../comum/components/FooterContent";
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import ModalAviso from "../../comum/components/ModalAviso";
import CargaGeralCard from "./CargaGeralCard";

@inject("store")
@observer
export class TabelaCargaGeralNova extends Component{

    constructor(props) {
        super(props);

        this.controller = this.props.controller;
    };

    modalFinalizarAgendamento() {
        if (!this.controller.salvando) return null;
        return (<div>
                    <ModalContainer zIndex={100}>
                        <ModalDialog className="nosso-modal">
                            <div>
                                <h2>Finalizando o agendamento, aguarde alguns instantes:</h2>
                            </div>
                            <br/>
                            <div className={`modal-aviso`}>
                                <div className="modal_i">
                                <div className="loader_i"></div>
                                </div>
                            </div>
                        </ModalDialog>
                    </ModalContainer>
                </div>)
// 
    }


    render() {
        return (
            <Container fluid className="tabela-container tabela-cabotagem-novas">
                {this.modalFinalizarAgendamento()}
                <ToolkitProvider
                    keyField="pos"
                    data={[...this.controller.novasCargas]}
                    columns={[...this.controller.colunasN]} >
                    {props => (
                        <div>
                            { window.innerWidth > 991
                                ? <BootstrapTable bootstrap4
                                                  striped
                                                  bordered={false}
                                                  noDataIndication={() => this.controller.noData}
                                                  classes="tabela tabela-layout cabotagem"
                                                  {...props.baseProps} />
                                : <Row>
                                    {this.controller.novasCargas.map((card, x) => (
                                        <CargaGeralCard
                                            controller={this.controller}
                                            key={x}
                                            data={card}
                                            id={x}
                                            colunas={[...this.controller.colunasN]}
                                            titulo={"NavioNome"}
                                            subtitulo={"Viagem"}

                                        />
                                    )) }
                                </Row>
                            }
                             
                        </div>)
                    }
                </ToolkitProvider>


                <Footer className = "justify-content-end">
                <div className="left-pos">
                            { this.controller.novasCargas.length > 0 && !this.controller.salvando
                                ? <div><b>{this.controller.novasCargas.length}</b> 
                                
                                {this.controller.novasCargas.length == 1 ? <b> Registro</b> : <b> Registros</b>}
                               
                                </div>
                                : <div>
                               
                                    </div>
                                }
                            </div>
                    { !this.controller.salvando
                        ? <React.Fragment>
                            <Button className="btn-primary" onClick={ () => this.controller.cancelarEnviar() }>CANCELAR</Button>
                            <Button className="btn-primary" onClick={ () => this.controller.salvarNovas() }>SALVAR AGENDAMENTOS</Button>
                        </React.Fragment>
                        : <IconeCarregar tamanho="2x" cor="#001C43" />
                    }
                </Footer>
            </Container>
            
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/carga-geral/components/TabelaCargaGeralNova.js